var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationHat = function SvgGraduationHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.358 3.179a1.088 1.088 0 0 0-.266-.111.5.5 0 0 0-.184 0 1.088 1.088 0 0 0-.266.11L2 8l9.642 4.821c.131.066.197.098.266.111.06.012.123.012.184 0 .069-.013.135-.045.266-.11L22 8l-9.642-4.821Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5v5.081c0 .335 0 .502.049.652a1 1 0 0 0 .206.36c.105.117.25.201.539.37l4.4 2.567c.293.171.44.257.596.29.139.03.282.03.42 0 .156-.033.303-.119.596-.29l4.4-2.567c.29-.169.434-.253.54-.37a1 1 0 0 0 .206-.36c.048-.15.048-.317.048-.652V10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5a1 1 0 1 0 2 0H1Zm2 0V8H1v7.5h2Z",
    fill: "currentColor"
  })));
};
export default SvgGraduationHat;